import types from "./types";

const INITIAL_STATE = {
	customer_survey: null,
	customer_surveyError: null,
	customer_surveyLoading: false,

	//create
	createcustomer_survey: null,
	createcustomer_surveyError: null,
	createcustomer_surveyLoading: false,

	//update
	updatecustomer_survey: null,
	updatecustomer_surveyError: null,
	updatecustomer_surveyLoading: false,

	//delete
	deletecustomer_survey: null,
	deletecustomer_surveyError: null,
	deletecustomer_surveyLoading: false,

	//single item

	singleItem: null,
};

const CustomerSurveyReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case types.GET_CUSTOME_SURVEY_START:
			return {
				...state,
				customer_survey: null,
				customer_surveyError: null,
				customer_surveyLoading: true,
			};
		case types.GET_CUSTOME_SURVEY_SUCCESS:
			return {
				...state,
				customer_survey: action.payload,
				customer_surveyLoading: false,
			};
		case types.GET_CUSTOME_SURVEY_ERROR:
			return {
				...state,
				customer_surveyError: action.payload,
				customer_surveyLoading: false,
			};
		case types.GET_CUSTOME_SURVEY_RESET:
			return {
				...state,
				customer_surveyError: null,
				customer_surveyLoading: false,
			};
		//create

		case types.CREATE_CUSTOME_SURVEY_START:
			return {
				...state,
				createcustomer_survey: null,
				createcustomer_surveyError: null,
				createcustomer_surveyLoading: true,
			};
		case types.CREATE_CUSTOME_SURVEY_SUCCESS:
			return {
				...state,
				createcustomer_survey: action.payload,
				createcustomer_surveyLoading: false,
			};
		case types.CREATE_CUSTOME_SURVEY_ERROR:
			return {
				...state,
				createcustomer_surveyError: action.payload,
				createcustomer_surveyLoading: false,
			};
		case types.CREATE_CUSTOME_SURVEY_RESET:
			return {
				...state,
				createcustomer_surveyError: null,
				createcustomer_surveyLoading: false,
			};
		//delete

		case types.DELETE_CUSTOME_SURVEY_START:
			return {
				...state,
				deletecustomer_survey: null,
				deletecustomer_surveyError: null,
				deletecustomer_surveyLoading: true,
			};
		case types.DELETE_CUSTOME_SURVEY_SUCCESS:
			return {
				...state,
				deletecustomer_survey: action.payload,
				deletecustomer_surveyLoading: false,
			};
		case types.DELETE_CUSTOME_SURVEY_ERROR:
			return {
				...state,
				deletecustomer_surveyError: action.payload,
				deletecustomer_surveyLoading: false,
			};
		case types.DELETE_CUSTOME_SURVEY_RESET:
			return {
				...state,
				deletecustomer_survey: null,
				deletecustomer_surveyError: null,
				deletecustomer_surveyLoading: false,
			};

		//update
		case types.UPDATE_CUSTOME_SURVEY_START:
			return {
				...state,
				updatecustomer_survey: null,
				updatecustomer_surveyError: null,
				updatecustomer_surveyLoading: true,
			};
		case types.UPDATE_CUSTOME_SURVEY_SUCCESS:
			return {
				...state,
				updatecustomer_survey: action.payload,
				updatecustomer_surveyLoading: false,
			};
		case types.UPDATE_CUSTOME_SURVEY_ERROR:
			return {
				...state,
				updatecustomer_surveyError: action.payload,
				updatecustomer_surveyLoading: false,
			};
		case types.UPDATE_CUSTOME_SURVEY_RESET:
			return {
				...state,
				updatecustomer_survey: null,
				updatecustomer_surveyError: null,
				updatecustomer_surveyLoading: false,
			};
		//singleItem
		// case types.SINGLE_CUSTOME_SURVEY_START:
		// 	return {
		// 		...state,
		// 		updatecustomer_survey: null,
		// 		updatecustomer_surveyError: null,
		// 		updatecustomer_surveyLoading: true,
		// 	};
		// case types.SINGLE_CUSTOME_SURVEY_SUCCESS:
		// 	return {
		// 		...state,
		// 		updatecustomer_survey: action.payload,
		// 		updatecustomer_surveyLoading: false,
		// 	};
		// case types.SINGLE_CUSTOME_SURVEY_ERROR:
		// 	return {
		// 		...state,
		// 		updatecustomer_surveyError: action.payload,
		// 		updatecustomer_surveyLoading: false,
		// 	};
		// case types.SINGLE_CUSTOME_SURVEY_RESET:
		// 	return {
		// 		...state,
		// 		updatecustomer_surveyError: null,
		// 		updatecustomer_surveyLoading: false,
		// 	};

		default:
			return { ...state };
	}
};

export default CustomerSurveyReducer;
